import { Can } from 'providers/casl'

export const onAbTestsAccess = (can: Can) => {
  can('access', 'AbTestsPage-list')
  can('access', 'AbTestsPage-add')
  can('access', 'AbTestsPage-edit')
}

export const onAbTestsCreateUpdateDelete = (can: Can) => {
  can('create', 'AbTests')
  can('update', 'AbTests')
  can('delete', 'AbTests')
}
